import React from 'react'

import { Container, Content, CommunitySpan } from '../styles/emailList.styles'

export default function EmailList() {
  return (
    <Container>
      <Content>
        <div>
          <h2>
            <label htmlFor="email">
              Join the <CommunitySpan>TechBlog Community</CommunitySpan> today!
            </label>
          </h2>
        </div>
        <div>
          <form>
            <span>
              <input id="email" placeholder="Your email" spellCheck="false" />
            </span>
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </Content>
    </Container>
  )
}
